// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"520f00ad","87":"e3f97720","107":"40b9ffe8","207":"8f6fe657","294":"4d4284c0","358":"e15c5ab7","428":"0efa12f3","468":"9cddc2b1","627":"d56c0415","787":"1a215750","805":"4afd572c","857":"dba99df1","896":"b3e18b05"}[chunkId] + ".chunk.js";
};